import React from 'react';
/* eslint-disable */
export const IconMenuClose = () => (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.92334 0C2.20422 0 0 2.20426 0 4.92334V22.7705C0 25.4895 2.20422 27.6938 4.92334 27.6938H22.155C23.1746 27.6938 24.0013 26.8672 24.0013 25.8476V24.6167H4.92334C3.90368 24.6167 3.07709 23.7901 3.07709 22.7705C3.07709 21.7508 3.90368 20.9242 4.92334 20.9242H24.0013V1.84625C24.0013 0.826592 23.1746 0 22.155 0H4.92334Z" fill="white"/>
    </svg>
);
